// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"42":"a68777bf","87":"92807b10","674":"996dfdb9","734":"2a523658"}[chunkId] + ".css";
};